import { createStore, applyMiddleware, compose } from "redux";
import promiseMiddleware from "redux-promise-middleware";

import reducer from "./ducks";

function configureStore(initialState = undefined) {
  const enhancers = compose(
    applyMiddleware(promiseMiddleware),
    process.env.NODE_ENV === "development" &&
      typeof window !== "undefined" &&
      typeof window.devToolsExtension !== "undefined"
      ? window.devToolsExtension()
      : (f) => f,
  );

  const store = initialState
    ? createStore(reducer, initialState, enhancers)
    : createStore(reducer, enhancers);

  return store;
}

export default configureStore;
